import {mapActions, mapGetters, mapMutations} from 'vuex';

import FacebookWidget from '@/components/widgets/facebook/index.vue';
import GoogleWidget from '@/components/widgets/google/index.vue';
import AppleWidget from '@/components/widgets/apple/index.vue';
import {VueTelInput} from 'vue-tel-input';
import mainSelect from '@/components/atoms/main-select/index.vue';
import mainInput from '@/components/atoms/main-input/index.vue';

import {email, maxLength, minLength, required, sameAs} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import {emailFormatter} from "@/mixins/validation";

export default {
    name: 'registration',
    mixins: [validationMixin],
    data() {
        return {
            payload: {
                email: '',
                phone: '',
                password: '',
                full_name: '',
                consent: false,
                country_id: '',
                country: {},
                provider: '',
                token: ''
            },
            isSocial: false,
            showPassword: false,
            selectedCountry: {},
            isValidPhone: false,
            openSelectCountries: false,
            validationErrors: {
                phone: []
            }
        }
    },
    validations() {
        if (this.isSocial) {
            return {
                payload: {
                    full_name: {
                        required,
                        maxLength: maxLength(50)
                    },
                    country: {
                        required,
                    },
                    country_id: {
                        required,
                    },
                    email: {
                        required,
                        email: (val) => email(emailFormatter(val)),
                        maxLength: maxLength(50)
                    },
                    password: {
                        minLength: minLength(10),
                        maxLength: maxLength(50)
                    },
                    consent: {
                        sameAs: sameAs(() => true)
                    }
                }
            }
        } else {
            return {
                payload: {
                    full_name: {
                        required,
                        maxLength: maxLength(50)
                    },
                    country: {
                        required,
                    },
                    country_id: {
                        required,
                    },
                    email: {
                        required,
                        email: (val) => email(emailFormatter(val)),
                        maxLength: maxLength(50)
                    },
                    password: {
                        required,
                        minLength: minLength(10),
                        maxLength: maxLength(50)
                    },
                    consent: {
                        sameAs: sameAs(() => true)
                    }
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            loadingRegistration: 'auth/loadingRegistration',
            config: 'setting/config',
            countries: 'setting/countries',
            countriesLoading: 'setting/countriesLoading',
            loadingUser: 'user/loadingUser',
            userHomework: 'userHomework/list'
        }),
        disableButton() {
            if (
                this.payload.full_name === '' ||
                !this.isValidPhone ||
                !this.payload.consent ||
                this.payload.email === '' ||
                this.payload.password === ''
            ) {
                return true
            } else {
                return false
            }
        },
        acceptAgreementError() {
            let error = [];
            if (!this.$v.payload.consent.$dirty) {
                return error;
            }
            if (!this.$v.payload.consent.sameAs) {
                error.push(this.$t('validateAcceptAgreement'));
            }
            return error;
        },
        fullNameErrors() {
            let error = [];
            if (!this.$v.payload.full_name.$dirty) {
                return error;
            }
            if (!this.$v.payload.full_name.required) {
                error.push(this.$t('validationRequired'))
            }
            if (!this.$v.payload.full_name.maxLength) {
                error.push(this.$t('maxLengthField')
                    .replace(':field', this.$t('firstNameAnfLastName'))
                    .replace(':count', 50));
            }
            if (this.validationErrors.full_name) {
                this.validationErrors.full_name.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
        emailErrors() {
            let error = [];
            if (!this.$v.payload.email.$dirty) {
                return error;
            }
            if (!this.$v.payload.email.required) {
                error.push(this.$t('validationRequired'))
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t('validationEmail'))
            }
            if (!this.$v.payload.email.maxLength) {
                error.push(this.$t('maxLengthField')
                    .replace(':field', this.$t('emailFieldShort'))
                    .replace(':count', 50));
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
        passwordErrors() {
            let error = [];
            if (!this.$v.payload.password.$dirty) {
                return error;
            }
            if (!this.$v.payload.password.required && !this.isSocial) {
                error.push(this.$t('validationRequired'));
            }
            if (!this.$v.payload.password.minLength) {
                error.push(this.$t('minLengthField')
                    .replace(':field', this.$t('passwordField'))
                    .replace(':count', 10));
            }
            if (!this.$v.payload.password.maxLength) {
                error.push(this.$t('maxLengthField')
                    .replace(':field', this.$t('passwordField'))
                    .replace(':count', 50));
            }
            if (this.validationErrors.password) {
                this.validationErrors.password.forEach((row) => {
                    error.push(row);
                })
            }
            return error;
        }
    },
    watch: {
        '$route'() {
            this.setFormsFields();
        },
    },
    created() {

        this.setFormsFields();
        if (this.countries.length <= 0) {
            this.fetchCountries().then(() => {
                this.setDefaultCountry();
            })
        } else {
            this.setDefaultCountry();
        }
    },
    components: {
        FacebookWidget,
        GoogleWidget,
        VueTelInput,
        AppleWidget,
        mainSelect,
        mainInput
    },
    methods: {
        ...mapActions({
            registration: 'auth/AUTH_REGISTRATION',
            checkFreeEmail: 'auth/CHECK_FREE_EMAIL',
            fetchCountries: 'setting/GET_COUNTRIES',
            singIn: `auth/AUTH_LOGIN`,
            auth: `auth/AUTH_WITH_SOCIAL`,
            fetchUser: `user/GET_USER_DATA`,
            fetchUserHomeWork: `userHomework/GET_LIST`,
            attachTest: `tests/ATTACH_TESTS`,
        }),

        ...mapMutations({
            showSendConfirmRegistrationPopup: 'system/SHOW_POPUP_TEXT_CONTENT',
            setDataToContentPopup: 'system/POPUP_TEXT_CONTENT'
        }),
        setDefaultCountry() {
            const item = this.countries.find(e => {
                if (e.id === 242) {
                    return e;
                }
            });
            this.payload.country = item;
            this.payload.country_id = item.id;
            this.countryKey = item.slug;
        },
        setFormsFields() {
            const objQuery = this.$route.query;
            if (objQuery.hasOwnProperty('isSocial') &&
                objQuery.hasOwnProperty('full_name') &&
                objQuery.hasOwnProperty('image') &&
                objQuery.hasOwnProperty('token') &&
                objQuery.hasOwnProperty('provider') &&
                objQuery.hasOwnProperty('email')) {
                if (objQuery.isSocial) {
                    this.isSocial = true;
                    this.payload.full_name = objQuery.full_name;
                    this.payload.email = objQuery.email;
                    this.payload.image = objQuery.image;
                    this.payload.token = objQuery.token;
                    this.payload.provider = objQuery.provider;

                    this.$v.$reset();

                    this.$v.$touch();
                    this.changeValidationPhone();
                }
            }
        },
        changePhoneInput(number, info) {
            this.isValidPhone = info.valid;
            if (this.isValidPhone) {
                this.payload.phone = info.number.e164.replace('+', '');
                this.validationErrors.phone = [];
            }
        },
        changeValidationPhone() {
            this.validationErrors.phone = [];
            if (this.payload.phone.length > 0) {
                if (!this.isValidPhone) {
                    this.validationErrors.phone.push(this.$t('enterCorrectPhone'))
                } else {
                    this.validationErrors.phone = [];
                }
            } else {
                this.validationErrors.phone.push(this.$t('validationRequired'))
            }
        },
        submit() {
            this.$v.$touch();
            this.changeValidationPhone();
            if (!this.$v.$invalid && this.isValidPhone) {

                const selectedMethod = payload => {
                    if (this.isSocial) {
                        return this.auth(payload)
                    } else {
                        return this.registration(payload)
                    }
                };

                this.payload.country_id = this.payload.country.id;
                selectedMethod(this.payload)
                    .then(() => {
                        this.$toasted.success(this.$t('successRegistration'));
                        this.$toasted.success(this.$t('goSingInMessage'));
                        this.fetchUser().then(() => {
                            this.$router.push({name: 'courses'});
                            // check completed test when user non auth
                            if (localStorage.getItem('hasUserCompletedTestsWhenIsNonAuth')) {
                                this.attachTest().then(() => {
                                    localStorage.removeItem('hasUserCompletedTestsWhenIsNonAuth')
                                }).catch(error => {
                                    if (error.response.status === 422) {
                                        this.$toasted.error(error.response.data.message);
                                    }
                                })
                            }
                        });
                    }).catch(error => {
                    if (error.response.status === 422) {
                        Object.assign(this.validationErrors, error.response.data.validation);
                    }
                });
            }
        }
    }
}
